import dayjs from "dayjs";
import store from "@/store";

const passwordRegex = /^.*(?=^.{8,16}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*-+?]).*$/;
const emailRegex = /^[\da-zA-Z]([-_.]?[\da-zA-Z])*@[\da-zA-Z]([-_.]?[\da-zA-Z])*.[a-zA-Z]{2,3}$/i;
const phoneRegex = /^\d{3}-\d{3,4}-\d{4}$/;
const swiperSortOrder = {
    0: [4, 5, 32, 33], //스마트
    1: [6, 7, 30, 31], //골드
    2: [10, 11, 22, 28, 29], //플레티넘
    3: [34], //제네시스 스마트80
    4: [35], //제네시스 스마트 A
    5: [36], //제네시스 스마트 B
    6: [37], //신한 법인 골드
    7: [39, 40, 52, 53, 54, 55, 56, 57], //제주 호텔 이후 스마트
    8: [41, 42, 52, 53, 54, 55, 56, 57], //제주 호텔 이후 골드
    9: [43, 44, 52, 53, 54, 55, 56, 57], //제주 호텔 이후 플레티넘
    10: [45], //제주 호텔 이후 제네시스 스마트 80
    11: [46], //제주 호텔 이후 제네시스 스마트 70 A
    12: [47], //제주 호텔 이후 제네시스 스마트 70 B
    13: [48], //제주 호텔 이후 신한 법인 골드
    14: [49], //양양 스마트 A
    15: [50], //양양 스마트 B
    16: [51], //양양 골드
    17: [75, 76, 63, 62, 61, 60, 59, 58 ], //스마트
    18: [74, 73, 63, 62, 61, 60, 59, 58 ], //골드
    19: [72, 71, 63, 62, 61, 60, 59, 58 ], //플래티넘
    20: [70], //제네시스 스마트 80
    21: [69], //제네시스 스마트 A
    22: [68], //제네시스 스마트 B
    23: [67], //신한 법인 골드
    24: [66], //양양 스마트 A
    25: [65], //양양 스마트 B
    26: [64], //양양 스마트 골드
    27: [78], //쟈스민 스마트
    28: [77], //쟈스민 골드
    //-------202406----------
    29: [79], //쟈스민 블루 전용_더파르나스 스마트
    30: [80], //쟈스민 블랙 전용_더파르나스 골드
    31: [81, 82, 94, 95], //스마트, 스마트 갱신, 스마트 식음형, 스마트 식음형 갱신
    32: [83, 84, 96, 97], //골드, 골드 갱신, 골드 식음형, 골드 식음형 갱신
    33: [85, 86, 98, 99], //플래티넘, 플래티넘 갱신, 플래티넘 식음형, 플래티넘 식음형 갱신
    34: [87], //제네시스 스마트 80
    35: [88], //제네시스 스마트 A
    36: [89], //제네시스 스마트 B
    37: [90], //신한 법인 골드
    38: [91], //인스케이프 양양 스마트 A
    39: [92], //인스케이프 양양 스마트 B
    40: [93], //인스케이프 양양
    // ------202408-------
    41: [100], //제네시스 EV G80
    // ------2025-------
    42: [101, 102, 114, 115], //스마트, 스마트 갱신, 스마트 식음형, 스마트 식음형 갱신
    43: [103, 104, 116, 117], //골드, 골드 갱신, 골드 식음형, 골드 식음형 갱신
    44: [105, 106, 118, 119], //플래티넘, 플래티넘 갱신, 플래티넘 식음형, 플래티넘 식음형 갱신
    45: [107], //제네시스 스마트 80
    46: [108], //제네시스 스마트 A
    47: [109], //제네시스 스마트 B
    48: [110], //신한 법인 골드
    49: [111], //인스케이프 양양 스마트 A
    50: [112], //인스케이프 양양 스마트 B
    51: [113], //인스케이프 양양 골드
    52: [120], //쟈스민 블루 전용_더파르나스 스마트
    53: [121], //쟈스민 블랙 전용_더파르나스 골드
    54: [122], //쟈스민 전용_더파르나스 스마트
    55: [123], //신한더프리미어 스마트
    56: [124], //제네시스 스마트 EV G80 멤버십
    // ------202502-------
    57: [125], //[THE O 전용] 더파르나스 아이초이스 스마트 멤버십
    58: [126], //랜드로버 전용_더파르나스 플래티넘 A / The Parnas P 2025 / 랜드로버A / 126
    59: [127], //랜드로버 전용_더파르나스 플래티넘 B / The Parnas P 2025 / 랜드로버B / 127
    // ------202509-------
    60: [128, 129], //스마트 식음 선택형 갱신, 스마트 식음 선택형
    61: [130, 131], //스마트 기본형 갱신, 스마트 기본형
    62: [132, 133], //플래티넘 갱신, 플래티넘
    63: [134, 135], //골드 갱신, 골드
    64: [136], //투체어스 블랙 전용_더파르나스 골드
    65: [137], //투체어스 블루 전용_더파르나스 골드
    66: [138], //두나무 VIP 전용_더파르나스 골드
    67: [139], //두나무 VVIP 전용_더파르나스 플래티넘
    // ------2026------- (MembershipBenefit.vue 의 슬라이드 순서와 같아야 한다. 빠지면 "상세 혜택 보기"에서 화면이 멈춘다)
    68: [140, 141], //스마트
    69: [142, 143], //스마트 식음형
    70: [144, 145, 152, 153], //골드
    71: [146, 147, 154, 155], //플래티넘
    72: [148], //제네시스 EV G80 LWB
    73: [149], //제네시스 스마트 B70 B
    74: [150], //제네시스 스마트 B70 A
    75: [151], //제네시스 스마트 80
    76: [156], //KB 헤리티지 스마트
    77: [157], //롯데카드 스마트
    78: [158], //인스케이프 양양 골드
    79: [159], //인스케이프 양양 스마트 B
    80: [160], //인스케이프 양양 스마트 A
    81: [161], //신한 골드
    82: [162], //신한 더 프리미어 스마트
    83: [163], //쟈스민 블랙 전용_더파르나스 골드
    84: [164], //쟈스민 블루 전용_더파르나스 스마트
    85: [165], //쟈스민 온리 더파르나스 스마트
    86: [166], //더오 아이초이스 스마트
    87: [167], //랜드로버 B 더파르나스 플래티넘
    88: [168], //랜드로버 A 더파르나스 플래티넘
    89: [169], //두나무 VVIP 플래티넘
    90: [170], //두나무 VIP 골드
    91: [171], //투체어스 블루 골드
    92: [172], //투체어스 블랙 골드
    93: [173], //파르나스 웨딩 플래티넘
    94: [174], //롯데카드 스마트 선택형
    95: [175], //KB 헤리티지 골드

}

// /**
//  * 한국어만 입력되도록 체크
//  * @param text:String
//  * @returns Boolean
//  */
// function checkOnlyKorean(text) {
//     return onlyKorean.test(text);
// }
/**
 * 비밀번호 정규식 메소드 8-16자리, 대문자, 소문자, 숫자, 특수문자
 * @param password
 * @returns Boolean
 */
function checkPasswordRule(password) {
    return passwordRegex.test(password);
}

/**
 * 이메일 정규식 메소드
 * @param email
 * @returns {boolean}
 */
function checkEmailRule(email) {
    return emailRegex.test(email);
}

function checkPhoneRule(phoneNumber) {
    return phoneRegex.test(phoneNumber);
}

/**
 * 마스킹 이메일 처리 wl*****@naver.com
 */
function maskingEmail(email) {
    if (email === undefined || email === '') {
        return email;
    }
    let len = email.split('@')[0].length - 3;
    return email.replace(new RegExp('.(?=.{0,' + len + '}@)', 'g'), '*');
}


/**
 * 마지막 글자를 * 처리한다. (ex. 홍길동 → 홍길*)
 * @param strName
 * @returns {*}
 */
function maskingName(strName) {
    if (strName === undefined || strName === '') {
        return strName;
    }
    let pattern = /.$/; // 정규식
    return strName.replace(pattern, "*");
}

/**
 * 날짜형식 YYYY-MM-DD
 */
function makeDateFormatYYYYMMDD(date) {
    return dayjs(date).format(`YYYY-MM-DD`)
}

/**
 * 객체 안에 키값이 있는지 확인
 * @param obj
 * @param key
 * @returns {boolean}
 */
function isKeyExists(obj, key) {
    return obj[key] !== undefined;
}

/**
 * null 체크
 * @param value
 * @returns {boolean}
 */
function isEmpty (value) {
    return value === "" ||
        value === null ||
        value === undefined ||
        (typeof value === "object" && !Object.keys(value).length);
}

async function initUserData() {
    await store.commit("resetMember");
    await store.commit("resetAuth");
    await store.commit("resetCouponStates");
    await store.commit("setMenuClose");
    sessionStorage.setItem('isLogin', 'false')
}

export const makeSwiper = (membershipId) => {
    let result = null
    for(let index in swiperSortOrder) {
        // console.log(index);

        if(swiperSortOrder[`${index}`].includes(membershipId)) {
            result = Number(index)
        }
    }

    return result
}

export {
    checkPasswordRule,
    checkEmailRule,
    checkPhoneRule,
    maskingEmail,
    maskingName,
    makeDateFormatYYYYMMDD,
    isKeyExists,
    isEmpty,
    initUserData,
    // checkOnlyKorean
}